import PatientConsentForm from './PatientConsentForm';

export default PatientConsentForm;
